import { useEnhancedAccessibility } from 'stores/UserStore'

export const Accessibility = ({ standardA11yComponent, enhancedA11yComponent = null }) => {
    const enhancedAccessibility = useEnhancedAccessibility()

    return enhancedAccessibility ? enhancedA11yComponent : standardA11yComponent
}
